import { useEffect } from 'react'
import { Switch } from 'antd'
import withRepeater from './withRepeater'

SequencedFormSwitchInput = ({
  form
  formItem
  repeatItem
  repeatableItems
  referrableData
  controlled
  save = {}
  nodeId
  props...
}) ->
  { onKey = { value: true, label: 'Yes' }, offKey = { value: false, label: 'No' } } = save
  { refNode } = referrableData if referrableData

  useEffect( ->
    unless props.value?
      props.onChange(false)
  , [])

  <Switch
    getter="checked"
    checkedChildren={onKey.label}
    unCheckedChildren={offKey.label}
    checked={props.value? && props.value || false}
    { props... }
  />

export default withRepeater(
  SequencedFormSwitchInput, { getter: 'checked', selector: (checked) -> checked }
)
